import Informacion from "../components/Informacion";


function Home() {
  return (
  <>
  
  <Informacion></Informacion></>
  );
}

export default Home;
